import { Link } from "react-router-dom";

export function Footer() {
    return (
        <footer className="border-t-2 border-black bg-white py-10 px-6">
            <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 font-mono-tag text-xs text-black">
                <div className="flex items-center gap-2">
                    <img
                        src="/logo-scorpionpdf.png"
                        alt="Logo ScorpionPDF"
                        className="w-7 h-7 object-contain"
                        width="28"
                        height="28"
                    />
                    <span className="font-bold">SCORPIONPDF</span>
                    <span> · Ferramentas online seguras</span>
                </div>
                <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 font-bold" aria-label="Rodapé">
                    <Link to="/privacidade" className="hover:text-[#0284C7]" data-testid="footer-privacidade">Privacidade</Link>
                    <Link to="/termos" className="hover:text-[#0284C7]" data-testid="footer-termos">Termos</Link>
                    <Link to="/contato" className="hover:text-[#0284C7]" data-testid="footer-contato">Contato</Link>
                    <Link to="/faq" className="hover:text-[#0284C7]" data-testid="footer-faq">FAQ</Link>
                    <Link to="/status" className="hover:text-[#0284C7]" data-testid="footer-status">Status</Link>
                </nav>
                <span>© 2026 SCORPIONPDF.</span>
            </div>
        </footer>
    );
}
